<div class="modal-header gll-modal-header">
  <div class="gll-header-icon">
    <i class="fa-solid fa-book"></i>
  </div>
  <div class="gll-header-body">
    <div class="gll-header-title" translate>Leçons</div>
    <div class="gll-header-sub">{{ level?.name }}</div>
  </div>
  <button type="button" class="gll-close-btn" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body gll-modal-body">

  <app-spinner *ngIf="loader"></app-spinner>

  <ng-container *ngIf="!loader">

    <div class="gll-count-label">
      <i class="fa-solid fa-layer-group"></i>
      {{ lessons.length }} <span translate>leçon(s)</span>
    </div>

    <div class="gll-list">
      <app-lesson-item *ngFor="let lesson of lessons; trackBy: trackById" [lesson]="lesson"></app-lesson-item>
    </div>

  </ng-container>

</div>
